
import { IconAccordionCaretDown, IconButton } from '@lmig/lmds-react-icons';
import { useEffect, useState } from 'react';
import { SitecoreFetch } from 'Api/api/SitecoreApi';
import { HttpStatusCodes, IServerResponse } from 'Utilities/ClientResponseUtility';
import { Popover } from '@lmig/lmds-react-popover';
import { ErrorBoundary } from 'react-error-boundary';
import { HandleErrorBoundaryCatch } from 'Utilities/ErrorHelper';
import './PageHeaderDropdown.scss';

interface IHeaderTopNavLinksResponse {
  links: IHeaderLink[] | null;
}

interface IHeaderLink {
  Link: {
    Anchor?: string;
    Class: string;
    Query?: string;
    Style?: string;
    Target: string;
    TargetId?: string;
    Text: string;
    Title?: string;
    Type?: number;
    Url: string;
  }
}

export const PageHeaderDropdown: React.FunctionComponent<{ headerLabel: string }> = (props) => {
  const { headerLabel } = props;
  const [isOpen, setIsOpen] = useState<boolean>();
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);
  const [headerTopNavLinks, setHeaderTopNavLinks] = useState<{
    links?: IHeaderLink[] | null;
    isLoaded: boolean;
  }>({links: null, isLoaded: false});
  const [responseStatus, setResponseStatus] = useState<{ statusCode: number; message: string }>({
    statusCode: HttpStatusCodes.OK,
    message: '',
  });
  
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

    useEffect(() => {
        if (!isLoading) return;
        if (headerTopNavLinks?.isLoaded) {
            setIsLoading(false);
            return;
        }
        
        const fetchData = async () => {
        setHeaderTopNavLinks({ links: null, isLoaded: false });
        let response = (await SitecoreFetch(`/api/sitecore/NowNavigationAsync/GetHeaderTopNavLinks`)) as IServerResponse;
        setResponseStatus({ statusCode: response.Status.Code, message: response.Status.Message });
        let result: IHeaderTopNavLinksResponse | null;
        if (response && response.Status?.Code === HttpStatusCodes.OK) {
            result = response?.Data as IHeaderTopNavLinksResponse;
            setHeaderTopNavLinks({ links: result?.links ?? null, isLoaded: true });
            
            console.log('Header Top Nav Links:', JSON.stringify(result?.links));

        } else {
            result = null;
            setIsServerError(true);
        }
        setIsLoading(false);
        };

        try {
        fetchData();
        } catch (error: any) {
        console.error(`${'PageHeader.GetHeaderTopNavLinks()'}() >> ${error.message}`);
        setIsServerError(true);
        setIsLoading(false);
        }
    }, []);

    return (
        <ErrorBoundary fallback={<HandleErrorBoundaryCatch component={"PageHeaderDropdown"} message={"PageHeaderDropdown render error"} />}>
            {headerTopNavLinks?.isLoaded && headerTopNavLinks.links && headerTopNavLinks.links.length > 0 && (
                <div className="top-nav-dropdown">
                    <Popover
                        variant="custom"
                        direction="below"
                        align="end"
                        className={isOpen ? 'open' : 'closed'}
                        onOpen={() => onOpen()}
                        onClose={() => onClose()}
                        trigger={
                            <IconButton background="transparent" >
                                <div className="icon-button-label">
                                    <span>{props?.headerLabel ?? ''}</span>
                                    {<IconAccordionCaretDown title="" />}
                                </div>
                            </IconButton>
                        }
                    >
                        <div className="popover-content">
                            <ul>
                                {(headerTopNavLinks.links)?.map((link) => (
                                <li>
                                    <a href={link.Link.Url} target={link.Link.Target} title={link.Link.Title} className={link.Link.Class}>
                                        {link.Link.Text}
                                    </a>
                                </li>))}
                            </ul>
                        </div>
                    </Popover>
                </div>
            )}
        </ErrorBoundary>
    )
};